import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function SocialProofBar() {
  return <FadeIn data-id="element-348">
      <div className="w-full bg-white border-y border-[#e2e8f0] py-6 shadow-sm" data-id="element-349">
        <div className="max-w-5xl mx-auto px-4 flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-center font-bold" data-id="element-350">
          <div className="text-lg text-[#0f172a]" data-id="element-351">+500 argentinos</div>
          <div className="hidden sm:block text-[#e2e8f0]" data-id="element-352">•</div>
          <div className="text-lg text-[#0f172a]" data-id="element-353">6 Tomos</div>
          <div className="hidden sm:block text-[#e2e8f0]" data-id="element-354">•</div>
          <div className="text-lg text-[#0f172a]" data-id="element-355">6 Bonos</div>
          <div className="hidden sm:block text-[#e2e8f0]" data-id="element-356">•</div>
          <div className="flex items-center gap-1 text-lg text-[#0f172a]" data-id="element-357">
            4,9/5
            <div className="flex text-[#22c55e] ml-1" data-id="element-358">
              <Star size={18} fill="currentColor" data-id="element-359" />
            </div>
          </div>
        </div>
      </div>
    </FadeIn>;
}